import React, { useMemo, useReducer, FunctionComponent, ReactNode } from 'react';
import { constructorContext } from './constructorContext';
import { constructorReducer } from '../../store/reducer';
import { Configurations } from '../../models';
import { createConstructorInitialConfig } from './utils';
import { useDidUpdate } from '@lt/components/hooks';
// @TODO
import { initAction } from '../../store/actions';

type Props = {
  children: ReactNode;
  config: Partial<Configurations>;
};

/** @desc начальные параметры */
const initialState = createConstructorInitialConfig();
export const ConstructorContextProvider: FunctionComponent<Props> = ({ children, config }) => {
  /**
   * пользователь может что-то указать в параметрах
   * смержим с предустановленными параметрами
   * */
  const data = useMemo(() => {
    return {
      ...initialState,
      ...config,
    };
  }, [config]);

  const [state, dispatch] = useReducer(constructorReducer, data);

  useDidUpdate(() => {
    dispatch(initAction(data));
  }, [data]);

  return (
    <constructorContext.Provider value={{ state, dispatch }}>
      {children}
    </constructorContext.Provider>
  );
};
